module.exports = __webpack_public_path__ + "img/u86.b98db3df.png";